module.exports = __webpack_public_path__ + "static/media/dan_postolea.c3da8588.png";